import { TFunction } from "i18next";
import * as Yup from "yup";

export const validationSchemaGeneralInfo = (t: TFunction) =>
  Yup.object().shape({
    projectName: Yup.string()
      .required(t("firstStep.required"))
      .min(5, t("firstStep.short"))
      .max(255, t("firstStep.long")),
  });

export const validationSchemaSeoSettings = (t: TFunction) =>
  Yup.object().shape({
    title: Yup.string().max(60, t("firstStep.long")),
    description: Yup.string().max(160, t("firstStep.long")),
    keywords: Yup.string().max(255, t("firstStep.long")),
  });

export const validationSchemaSocialLinks = (t: TFunction) =>
  Yup.object().shape({
    instagram: Yup.string().max(255, t("firstStep.long")),
    facebook: Yup.string().max(255, t("firstStep.long")),
    x: Yup.string().max(255, t("firstStep.long")),
    youtube: Yup.string().max(255, t("firstStep.long")),
    linkedin: Yup.string().max(255, t("firstStep.long")),
    tiktok: Yup.string().max(255, t("firstStep.long")),
  });

export const validationTicketSudomain = (t: TFunction) =>
  Yup.object().shape({
    subdomain: Yup.string()
      .required(t("firstStep.required"))
      .min(1, t("firstStep.short"))
      .max(255, t("firstStep.long"))
      .matches(/^[a-zA-Z0-9.-]+$/, t("validation.onlyEnglish")),
  });

export const validationDomain = (t: TFunction) =>
  Yup.object().shape({
    domain: Yup.string()
      .required(t("firstStep.required"))
      .min(1, t("firstStep.short"))
      .max(255, t("firstStep.long"))
      .matches(/\..+$/, t("validation.containDots"))
      .matches(/^[a-zA-Z0-9.-]+$/, t("validation.onlyEnglish")),
  });

export const validationSubdomain = (t: TFunction) =>
  Yup.object().shape({
    domain: Yup.string()
      .required(t("firstStep.required"))
      .min(1, t("firstStep.short"))
      .max(255, t("firstStep.long"))
      .matches(/^[a-zA-Z0-9.-]+$/, t("validation.onlyEnglish"))
      .test(
        "at-least-two-dots",
        t("validation.contain2Dots"),
        (value) => (value?.match(/\./g) || []).length >= 2
      ),
  });
